<template>
  <div>
    <div v-if="filter.type === 'date'">
      <v-menu
        v-model="menu[index]"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="appliedFilters[filter.key]"
            :label="i18n[filter.label]"
            prepend-icon="mdi-calendar"
            readonly
            :loading="loading"
            outlined
            hide-details
            dense
            :disabled="loading"
            :class="`${arabic?'arFont':'enFont'}`"
            clearable
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="appliedFilters[filter.key]"
          @input="menu[index] = false"
        ></v-date-picker>
      </v-menu>
    </div>
    <div v-if="filter.type === 'select'">
      <v-autocomplete
        :items="resource[filter.items]"
        v-model="appliedFilters[filter.key]"
        :label="i18n[filter.label]"
        autocomplete="disabled"
        outlined
        hide-details
        clearable
        dense
        :filter="filterObject"
        :disabled="loading"
        :loading="loading"
        :prepend-icon="`${filter.icon?filter.icon:'task_alt'}`"
        item-value="id"
        :class="`${ arabic ? 'arFont' : 'enFont' }`"
      >
        <template v-slot:selection="{ attr, on, item, selected }">
          <span
            v-bind="attr"
            :input-value="selected"
            v-on="on"
            :class="`${arabic?'arFont':'enFont'}`"
          >
            <v-chip x-small>{{selectItem(item)}}</v-chip>
          </span>
        </template>
        <template v-slot:item="{ item }">
          <span
            :class="`${arabic?'arFont':'enFont'}`"
          >
            {{selectItem(item)}}
          </span>
        </template>
      </v-autocomplete>
    </div>
    <div v-if="filter.type === 'switch'">
      <v-switch
        v-model="appliedFilters[filter.key]"
        inset
        hide-details
        dense
        class="mt-0"
        :label="i18n[filter.label]"
      ></v-switch>
    </div>
    <div v-if="filter.type === 'number'">
      <v-text-field
        :label="i18n[filter.label]"
        outlined
        hide-details
        dense
        @keypress="isNumber($event)"
        v-model="appliedFilters[filter.key]"
      >
      </v-text-field>
    </div>
  </div>
</template>

<script>
export default {
  components:{},
  props:['filter', 'appliedFilters', 'index', 'loading', 'resource'],
  data(){
    return{
      menu:{}
    }
  },
  methods:{
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    selectItem(obj) {
      let properties = ['title', 'name', 'label', 'slug', this.language, 'text']
      if(typeof obj === 'object') {
        for (let prop of properties) {
            if (obj.hasOwnProperty(prop)) {
                const i18nValue = this.getI18nValue(obj[prop]);
                return i18nValue || obj[prop];
            }
        }
        return obj.id;
      } else {
        const i18nValue = this.getI18nValue(obj);
        return i18nValue || obj;
      }

    },
    getI18nValue(key) {
        return this.i18n[key] || null;
    }

  },
  computed: {
    language(){
      return this.$store.state.language
    },
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
}
</script>

<style>

</style>